import React from 'react'

function Sidebar() {
  return (
    <div  className='bg-gray-400 text-white  w-1/6 p-4'>
        <li>Dashboard</li>
        <li>Manage Cars</li>
        <li>Settings</li>
        <li>Sign out</li>
    </div>
  )
}

export default Sidebar